module.exports = __webpack_public_path__ + "static/pravi-logo-e23afc8b2763a5ca3beeac9bf4264f76.svg";